// extracted by mini-css-extract-plugin
export default {"advanceTable":"advance-table__advanceTable","noDataWrapper":"advance-table__noDataWrapper","toolbar":"advance-table__toolbar","extraSpacing":"advance-table__extraSpacing"};